import type { DeployedUnit } from "../../api/types";

/** Fonctions de mêlée (infanterie, cavalerie et blindés, reconnaissance, groupements interarmes, aérocombat) :
 *  seules montrées par défaut sur la carte tactique (demande d'Alexis du 10/10/2026) ; les unités d'appui et de
 *  soutien paraissent avec la bascule « Appuis et soutien ». Population et irréguliers suivent leur camp. */
const MANEUVER_ARMS = new Set([
  "INFANTERIE",
  "INFANTERIE_MECA",
  "INFANTERIE_MOTO",
  "BLINDE",
  "CAVALERIE",
  "RECONNAISSANCE",
  "INTERARMES",
  "IRREGULIERS",
  "POPULATION",
]);

export function isManeuverUnit(unit: Pick<DeployedUnit, "arm" | "specialty">): boolean {
  if (!unit.arm || MANEUVER_ARMS.has(unit.arm)) return true;
  // Aérocombat (ALAT) : unité de mêlée, quelle que soit la fonction saisie.
  return /ALAT|AÉROCOMBAT|AEROCOMBAT|HÉLICO|HELICO|AVIATION/i.test(`${unit.arm} ${unit.specialty ?? ""}`);
}

/** Unité affichée selon la bascule « Appuis et soutien ». */
export function unitShown(unit: Pick<DeployedUnit, "arm" | "specialty">, supportsVisible: boolean): boolean {
  return supportsVisible || isManeuverUnit(unit);
}

/** Calque qui cache une unité posée : son camp (« Amis », « Ennemis »…) ou la bascule « Appuis et soutien ». */
export type MapMask = "side" | "supports";

/** Pourquoi une unité posée n'est pas dessinée sur la carte, null si elle l'est (mêmes conditions que
 *  `UnitsLayers`). Le constat de cohérence qui la désigne le dit, et « Voir » rouvre le calque (`MapMask`). */
export function unitMask(
  unit: Pick<DeployedUnit, "arm" | "specialty" | "side">,
  supportsVisible: boolean,
  sidesVisible: Partial<Record<DeployedUnit["side"], boolean>>,
): MapMask | null {
  if (sidesVisible[unit.side] === false) return "side";
  return unitShown(unit, supportsVisible) ? null : "supports";
}
